import React from "react";
import styled from "styled-components";

const Skeleton = ({ times }) => {
  const boxes = Array(times)
    .fill(0)
    .map((_, i) => {
      return (
        <SkeletonStyle>
          <div key={i} className="load-flex">
            <h1 className="skeleton skeleton-text"></h1>
            <div className="load"></div>
          </div>
        </SkeletonStyle>
      );
    });

  return boxes;
};

export default Skeleton;

const SkeletonStyle = styled.div`
  width: 100%;
  .skeleton {
    opacity: 0.7;
    margin: 0.2em 0;
    animation: skeleton-loading 1s linear infinite alternate;
    width: 100%;
  }

  .skeleton-text {
    width: 100%;
    height: 0.5rem;
    margin-bottom: 0.25rem;
    border-radius: 0.125rem;
  }

  .skeleton-text:last-child {
    margin-bottom: 0;
    width: 80%;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(200, 20%, 70%);
    }

    100% {
      background-color: hsl(200, 20%, 95%);
    }
  }
  .load-flex {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1em;
    grid-auto-flow: column;
    width: 100%;
    
}
.load {
      width: 100%;
    background-image: linear-gradient(90deg, lightgray, #9d9d9d, lightgray);
    animation: scroll 0.5s infinite;
    color: transparent;
    border-radius: 0.25rem;
    /*-webkit-background-clip: text;*/
  }

  div.load {
    display: flex;
  }

  .load * {
    z-index: 99;
  }

  @keyframes scroll {
    from {
      background-position: 0;
    }
    to {
      background-position: 100vw;
    }
  }
`;
